/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: logProfilesActions.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Navigation utilities for Log Profiles.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';

export const getLogProfileDuplicateUrl = (id: string | number): string =>
  `/log-profiles/new?duplicate=${id}`;

export const navigateToLogProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getLogProfileDuplicateUrl(id));
};

